import * as amplitude from "@amplitude/analytics-browser";
import { GeneralPermissions } from "@redotech/account-common/permissions";
import { useHasPermission } from "@redotech/redo-merchant-app-common/auth/permissions-context";
import { TeamContext } from "@redotech/redo-merchant-app-common/team";
import { NotificationBannerItem } from "@redotech/redo-web/arbiter-components/notification/redo-notification-banner";
import { useContext } from "react";
import { PlatformEvents } from "../../../platform-events";
import { ActionRequiredSeverity } from "./action-required-notification";

export function useNewPermissions(): {
  severity: ActionRequiredSeverity;
  item: NotificationBannerItem;
} | null {
  const team = useContext(TeamContext);
  const canAuthenticateWithThirdParties = useHasPermission(
    GeneralPermissions.AUTHENTICATE_WITH_THIRD_PARTIES,
  );
  if (!canAuthenticateWithThirdParties) {
    return null;
  }
  if (!team?.updatePermissionsLink) {
    return null;
  }

  return {
    severity: ActionRequiredSeverity.Medium,
    item: {
      id: "new-permissions",
      type: "warning",
      message:
        "Redo needs new permissions to continue providing the best experience.",
      actions: [
        {
          actionType: "link",
          href: team.updatePermissionsLink,
          text: "Update permissions",
          internal: false,
          onClick: () =>
            amplitude.track(
              PlatformEvents.PERMISSIONS_UPDATE_PERMISSIONS_CLICKED,
            ),
        },
      ],
    },
  };
}
